import { Box, Button, Icon } from '@inflearn/ds-react-next';
import { faFilePen, faPen, faStar as faSolidStar } from '@inflearn/pro-solid-svg-icons';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import { useCourseReviewContext } from '../CourseCardContainer';
import type { CourseCardData } from './courseCardDataTransformer';

export function FeedbackButtons({
  isReviewable,
  review,
  voucherId,
  course,
}: {
  isReviewable: boolean;
  review?: CourseCardData['review'];
  voucherId: number;
  course: CourseCardData['course'];
}) {
  const { t } = useTranslation();
  const { openReviewModal } = useCourseReviewContext();

  const onClick = () => {
    openReviewModal(voucherId);
  };

  if (course.isOfflineCourse && course.offlineCourse) {
    const { hasSurveyAnswer, canAnswerSurvey, surveyUrl, surveyReadonlyUrl } = course.offlineCourse;

    if (!hasSurveyAnswer && canAnswerSurvey) {
      return (
        <Button
          component={Link}
          target="_blank"
          href={surveyUrl}
          leftSection={<Icon icon={faFilePen} size="sm" />}
          variant="default"
          color="infgreen"
          size="xs"
          radius="md"
        >
          {t('설문 작성')}
        </Button>
      );
    }

    if (!hasSurveyAnswer) {
      // 배치 때문
      return <Box />;
    }

    return (
      <Button
        component={Link}
        target="_blank"
        href={canAnswerSurvey ? surveyUrl : surveyReadonlyUrl}
        leftSection={canAnswerSurvey ? <Icon icon={faPen} size="sm" /> : undefined}
        variant="default"
        color="infgreen"
        size="xs"
        radius="md"
      >
        {canAnswerSurvey ? t('설문 수정') : t('설문 보기')}
      </Button>
    );
  }

  if (isReviewable) {
    return (
      <Button onClick={onClick} variant="default" color="infgreen" size="xs" radius="md">
        {t('수강평 작성')}
      </Button>
    );
  }

  if (review) {
    return (
      <Button
        onClick={onClick}
        aria-label={t('수강평 수정')}
        leftSection={<Icon icon={faSolidStar} color="yellow.6" size="sm" />}
        variant="light"
        color="yellow"
        size="xs"
        radius="md"
      >
        {review.rating.toFixed(1)}
      </Button>
    );
  }

  return null;
}
